/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	const createElmFromStr = (str) => {
		return new DOMParser().parseFromString(str, "text/html").body.firstElementChild;
	};

	const createSitemap = () => {
		let csvPath = '/sitemap/';
		const output = document.querySelector('.js-sitemap-output');

		if(location.pathname.indexOf('/english/') !== -1) {
			csvPath = '/english/sitemap/';
		}
		const req = new XMLHttpRequest();
		req.open('get', csvPath + 'sitemap.csv', true);
		req.send(null);
		
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			let titleData = tmp[0].split(',');
			let type1Idx = titleData.indexOf('大カテゴリ');
			let type2Idx = titleData.indexOf('大カテゴリURL');
			let type3Idx = titleData.indexOf('中カテゴリ');
			let type4Idx = titleData.indexOf('中カテゴリURL');
			let type5Idx = titleData.indexOf('小カテゴリ');
			let type6IdxTemp = titleData.indexOf('小カテゴリURL\r');
			let type6Idx = type6IdxTemp !== -1 ? type6IdxTemp : titleData.indexOf('小カテゴリURL');
			
			let wrapName, ulName, ulName_sub;

			// タイトル列削除
			tmp.shift();
			
			tmp.forEach((val, idx) => {
				const data = val.split(',');
				// 大カテゴリ
				if(data[type1Idx] !== '' && data[type1Idx] !== undefined) {
					let _tit = data[type1Idx];
					let _url = data[type2Idx];
					wrapName = 'wrap-' + idx;

					let linkHtml = `<div><h3 class="mod-spacer-small">
						<a href="${_url}" class="mod-link01 _large">
							<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right_02"></use></svg>
							<span>${_tit}</span>
						</a>
					</h3>
					<div class="sitemap-wrap" data-name="${wrapName}"></div>
					</div>`;
					let tempEl = createElmFromStr(linkHtml);
					output.insertAdjacentElement("beforeend",tempEl);
				}
				
				// 中カテゴリ
				if(data[type3Idx] !== '' && data[type3Idx] !== undefined) {
					let _tit = data[type3Idx];
					let _url = data[type4Idx];
					let linkHtml = '';
					let prevItem = tmp[idx-1].split(',')[type3Idx];
					let _target = '_self';
					if(_url && _url.indexOf('//') !== -1) {
						_target = '_blank';
					}

					ulNameChild = 'ul-type01-child-' + idx;
					ulName = 'ul-type01-' + idx;
					linkHtml += '<ul class="sitemap-ul01 mod-spacer-24_20" data-name="'+ulName+'">';
					if(_url === '') {
						linkHtml += `<li class="" data-name="${ulNameChild}"><p class="fw_700 fs_20 fs_sp_16">${_tit}</p></li>`;
					} else {
						linkHtml += `<li class="" data-name="${ulNameChild}">
							<p class="fw_700 fs_20 fs_sp_16">
								<a href="${_url}" target=${_target} class="mod-link03">
									<span class="color_blue td_under">${_tit}</span>
								</a>
							</p>
						</li>`;
					}
					let tempEl = createElmFromStr(linkHtml);
					document.querySelector('div[data-name="'+ wrapName +'"]').insertAdjacentElement("beforeend",tempEl);
				}

				// 小カテゴリ
				if(data[type5Idx] !== '' && data[type5Idx] !== undefined) {
					let _tit = data[type5Idx];
					let _url = data[type6Idx];
					let linkHtml = '';
					let prevItem = tmp[idx-1].split(',')[type5Idx];
					let _target = '_self';
					let blankIcon = '';
					if(_url && _url.indexOf('//') !== -1) {
						_target = '_blank';
						blankIcon = '<svg class="icon"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg>';
					}
					if(prevItem === '') {
						ulName_sub = 'ul-type02-' + idx;
						linkHtml += '<ul class="sitemap-ul02 mod-spacer-20_16" data-name="'+ ulName_sub +'">';
						linkHtml += `<li class="mt5">
							<a href="${_url}" target=${_target} class="mod-link03">
								<span class="color_blue td_under">${_tit}</span>${blankIcon}
							</a>
						</li>`;
						let tempEl = createElmFromStr(linkHtml);
						document.querySelector('li[data-name="'+ ulNameChild +'"]').insertAdjacentElement("beforeend",tempEl);
					} else {
						if(_url === '') {
							linkHtml += `<li class="mt5">${_tit}</li>`;
							let tempEl = createElmFromStr(linkHtml);
							document.querySelector('ul[data-name="'+ ulName_sub +'"]').insertAdjacentElement("beforeend",tempEl);
						} else {
							linkHtml += `<li class="mt5">
								<a href="${_url}" target=${_target} class="mod-link03">
								<span class="color_blue td_under">${_tit}</span>${blankIcon}</a>
							</li>`;
							let tempEl = createElmFromStr(linkHtml);
							document.querySelector('ul[data-name="'+ ulName_sub +'"]').insertAdjacentElement("beforeend",tempEl);
						}
					}
				}
			});
		};
		return false;
	};

	if(document.getElementsByClassName('js-sitemap-output').length) {
		createSitemap();
	}

})(window.FUNCTIONS);
